const useSupportSearch = () => {
  const filterUndefinedCategoryItems = (category: any[]) => {
    const newCategory = category.filter((item: any) => item?.id !== "NULL_VALUE");
    return newCategory;
  }

  const mappingSortValue = (selectedValue: string | undefined, values: {label: string, value: string}[]) => {
    const mappedSortValue = values.find((item: any) => item.value === selectedValue);
    return mappedSortValue?.label;
  };

  return {
    filterUndefinedCategoryItems,
    mappingSortValue,
  }
}

export default useSupportSearch;